import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
function Footer() {
  return (
   
<>
<footer className="footer-sec">
      <div className="footer-container">
        {/* Left Side */}
        <div className="footer-left">
          <h4>LEGAL</h4>
          <ul>
            <li><Link to='/RefundPolicy'> Refund Policy</Link></li>
            <li><Link to='/PrivacyPolicy'> Privacy Policy</Link></li>
            <li><Link to='/TermsAndConditions'>Terms & Conditions</Link></li>
            <li><Link to='/EcoFarming'>Eco Farming</Link></li>
          </ul>
          <p className="copyright text-white">© 2023 Copyright. All Rights Reserved</p>
        </div>

        {/* Center Logo */}
        <div className="footer-center">
  <img src="./img/logo.png" alt="Logo" className="footer-logo" />
  <p className="footer-tagline">The best quality produce – from us to you</p>
  <div className="social-icons">
          {/* ✅ WhatsApp Button */}
          <a href="https://wa.me/923030977567" target="_blank" className="social-btn" title="Chat on WhatsApp" >
    <i className="fab fa-whatsapp"></i>
  </a>
    <a href="#" className="social-btn"><i className="fab fa-facebook-f"></i></a>
    <a href="#" className="social-btn"><i className="fab fa-instagram"></i></a>
    <a href="#" className="social-btn"><i className="fab fa-twitter"></i></a>

  </div>
</div>
        {/* Right Side */}
        <div className="footer-right">
          <h4>Head Office Address</h4>
          <p className='text-white'>18-E/2, Gulberg-III<br />Liberty Roundabout, Lahore, Pakistan</p>
          <h4>Contact</h4>
          <p className='text-white'>+92 303 0977 567<br />info@ahhintelgroup.com</p>
        </div>
      </div>
      
      <div class="developer-credit">
  <h5 class="dev-heading">Designed & Developed By</h5>
  <p class="dev-text text-center">
    <span class="dev-name">Danish Ali</span> | FullStack Website Developer | 📧 danishalich99@gmail.com | 📞 +92-308-2254455
  </p>

    {/* ✅ WhatsApp Button */}
    <a href="https://wa.me/923082254455" target="_blank" className="social-btn" title="Chat on WhatsApp" style={{marginRight:'20px',marginTop:'10px'}}>
    <i className="fab fa-whatsapp"></i>
  </a>

  {/* ✅ LinkedIn Button */}
  <a 
    href="https://www.linkedin.com/in/danish-ali-1398a6334?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
    target="_blank" 
    className="social-btn" 
    title="Connect on LinkedIn"
    style={{marginRight:'20px',marginTop:'10px'}}
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</div>

    </footer>
</>
  )
}

export default Footer
